// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.category-list,
.category-add,
.category-edit {
  padding: 24px;
}
.category-list .category-header-container {
  display: flex;
  justify-content: space-between;
  margin-bottom: 20px;
}

.category-header-container .blog-header {
  font-size: 2rem;
  font-weight: 600;
  font-family: Poppins;
}

.input {
  width: 100% !important;
}

/* --------------------------Global css------------------------- */
.category-add .btn-flex,
.category-edit .btn-flex {
  display: flex;
  margin-right: -20px;
}
.category-add .btn-flex .btn-container,
.category-edit .btn-flex .btn-container {
  margin-right: 20px;
}

.category-add .MuiPaper-root.MuiPaper-elevation .MuiAccordionDetails-root,
.category-edit .MuiPaper-root.MuiPaper-elevation .MuiAccordionDetails-root {
  padding: 0px !important;
}

.category-add .MuiPaper-root.MuiPaper-elevation:last-of-type,
.category-edit .MuiPaper-root.MuiPaper-elevation:last-of-type {
  position: fixed !important;
  top: 50% !important;
  left: 50% !important;
  width: 90% !important;
  max-width: 900px !important;
  max-height: 90vh !important;
  transform: translate(-50%, -50%) !important;
  overflow-y: auto !important;
  margin: 0 !important;
  z-index: 1400 !important; /* Higher than default MUI modal z-index */
  box-shadow: 0 11px 15px -7px rgba(0,0,0,0.2), 
              0 24px 38px 3px rgba(0,0,0,0.14), 
              0 9px 46px 8px rgba(0,0,0,0.12) !important;
}

/* Custom scrollbar */
.category-add .MuiPaper-root.MuiPaper-elevation:last-of-type::-webkit-scrollbar,
.category-edit .MuiPaper-root.MuiPaper-elevation:last-of-type::-webkit-scrollbar {
  width: 6px;
}

.category-add .MuiPaper-root.MuiPaper-elevation:last-of-type::-webkit-scrollbar-track,
.category-edit .MuiPaper-root.MuiPaper-elevation:last-of-type::-webkit-scrollbar-track {
  background: #f1f1f1;
}

.category-add .MuiPaper-root.MuiPaper-elevation:last-of-type::-webkit-scrollbar-thumb,
.category-edit .MuiPaper-root.MuiPaper-elevation:last-of-type::-webkit-scrollbar-thumb {
  background: #888;
  border-radius: 4px;
}

.category-add .MuiPaper-root.MuiPaper-elevation:last-of-type::-webkit-scrollbar-thumb:hover,
.category-edit .MuiPaper-root.MuiPaper-elevation:last-of-type::-webkit-scrollbar-thumb:hover {
  background: #555;
}

/* Responsive adjustments */
@media (min-width: 600px) {
  .category-add .MuiPaper-root.MuiPaper-elevation:last-of-type,
  .category-edit .MuiPaper-root.MuiPaper-elevation:last-of-type {
    width: 85% !important;
  }
}

@media (min-width: 900px) {
  .category-add .MuiPaper-root.MuiPaper-elevation:last-of-type,
  .category-edit .MuiPaper-root.MuiPaper-elevation:last-of-type {
    width: 75% !important;
  }
}

@media (min-width: 1200px) {
  .category-add .MuiPaper-root.MuiPaper-elevation:last-of-type,
  .category-edit .MuiPaper-root.MuiPaper-elevation:last-of-type {
    width: 60% !important;
  }
}
.Quil-one,
.Quil-two {
  padding: 0px 16px 16px;
}

.category-add .btn-group,
.category-edit .btn-group {
  display: flex;
  padding: 8px 16px 16px;
  justify-content: end;
}

.category-add .quil-close-btn,
.category-edit .quil-close-btn {
  margin-right: 10px;
}

/* category add component style */

.category-add .category-header-container {
  display: flex;
  justify-content: space-between;
  margin-bottom: 20px;
}

.container {
  margin-top: 60px;
  display: flex;
  align-items: center;
}
.label {
  /* font-size: 20px; */
  font-family: Poppins;
  font-size: 16px;
  font-weight: 600;
  margin: 0.3rem 0 0.2rem 0;
  color: #333;
  width: 25%;
}
.input {
  width: 100%;
  padding: 8px;
}

.Quil-maodal-header {
  background-color: ghostwhite;
  padding: 10px;
  display: flex;
  justify-content: space-between;
  font-family: "Roboto", "Helvetica", "Arial", sans-serif;
  font-weight: 400;
  font-size: 1rem;
  line-height: 1.5;
  letter-spacing: 0.00938em;
  font-weight: 600;
}

.Quil-one .title {
  font-weight: 600;
}
.Quil-two .title {
  font-weight: 600;
}

/* ------------------Edit Category style-------- */

.category-edit .category-header-container {
  display: flex;
  justify-content: space-between;
  margin-bottom: 20px;
  font-size: 2rem;
  font-weight: 600;
  font-family: Poppins;
}

.category-edit .container {
  align-items: center;
}
.question {
  font-family: "Roboto", "Helvetica", "Arial", sans-serif;
  font-weight: 700;
  font-size: 0.875rem;
  display: grid;
  grid-template-columns: 100px 500px;
  column-gap: 10px;
}
.answer {
  font-family: "Roboto", "Helvetica", "Arial", sans-serif;
  font-weight: 700;
  font-size: 0.875rem;
  margin-top: 25px;
  display: grid;
  grid-template-columns: 100px 500px 50px 50px;
  column-gap: 10px;
}

.quest-header {
  margin-right: 40px;
}

.category-edit .Quil-one,
.Quil-two {
  padding: 0px 16px 16px;
  font-family: Poppins;
  font-size: 16px;

  margin: 0.3rem 0 0.2rem 0;
  color: #333;
}

.category-add .Quil-one .ql-container,
.Quil-two .ql-container {
  height: 80px !important;
}
.category-edit .Quil-one,
.Quil-two title {
  font-family: Poppins;
  font-size: 16px;
  margin: 0.3rem 0 0.2rem 0;
  color: #333;
}

/* --------------------category-card---------------------- */
.category-card-container {
  width: calc(25% - 20px);
  margin: 10px;
}

.card-que-body {
  /* padding: 0.5rem;
  border-radius: 4px; */
  /* outline: none; */
  /* border: 1px solid #d1cece; */
  /* font-size: 16px; */
}

.faqs-error {
  font-family: Poppins;
  font-size: 14px;
  font-weight: 600;
  color: #f53232;
}
`, "",{"version":3,"sources":["webpack://./src/features/FaqCategory/category.css"],"names":[],"mappings":"AAAA;;;EAGE,aAAa;AACf;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,sBAAsB;AACxB;;AAEA,kEAAkE;AAClE;;EAEE,aAAa;EACb,mBAAmB;AACrB;AACA;;EAEE,kBAAkB;AACpB;;AAEA;;EAEE,uBAAuB;AACzB;;AAEA;;EAEE,0BAA0B;EAC1B,mBAAmB;EACnB,oBAAoB;EACpB,qBAAqB;EACrB,2BAA2B;EAC3B,2BAA2B;EAC3B,2CAA2C;EAC3C,2BAA2B;EAC3B,oBAAoB;EACpB,wBAAwB,EAAE,0CAA0C;EACpE;;wDAEsD;AACxD;;AAEA,qBAAqB;AACrB;;EAEE,UAAU;AACZ;;AAEA;;EAEE,mBAAmB;AACrB;;AAEA;;EAEE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;;EAEE,gBAAgB;AAClB;;AAEA,2BAA2B;AAC3B;EACE;;IAEE,qBAAqB;EACvB;AACF;;AAEA;EACE;;IAEE,qBAAqB;EACvB;AACF;;AAEA;EACE;;IAEE,qBAAqB;EACvB;AACF;AACA;;EAEE,sBAAsB;AACxB;;AAEA;;EAEE,aAAa;EACb,sBAAsB;EACtB,oBAAoB;AACtB;;AAEA;;EAEE,kBAAkB;AACpB;;AAEA,iCAAiC;;AAEjC;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,qBAAqB;EACrB,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,WAAW;EACX,UAAU;AACZ;AACA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,4BAA4B;EAC5B,aAAa;EACb,aAAa;EACb,8BAA8B;EAC9B,uDAAuD;EACvD,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;;AAEA,kDAAkD;;AAElD;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;AACrB;AACA;EACE,uDAAuD;EACvD,gBAAgB;EAChB,mBAAmB;EACnB,aAAa;EACb,kCAAkC;EAClC,gBAAgB;AAClB;AACA;EACE,uDAAuD;EACvD,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,aAAa;EACb,4CAA4C;EAC5C,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;;EAEE,sBAAsB;EACtB,oBAAoB;EACpB,eAAe;;EAEf,yBAAyB;EACzB,WAAW;AACb;;AAEA;;EAEE,uBAAuB;AACzB;AACA;;EAEE,oBAAoB;EACpB,eAAe;EACf,yBAAyB;EACzB,WAAW;AACb;;AAEA,4DAA4D;AAC5D;EACE,uBAAuB;EACvB,YAAY;AACd;;AAEA;EACE;uBACqB;EACrB,mBAAmB;EACnB,+BAA+B;EAC/B,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB","sourcesContent":[".category-list,\n.category-add,\n.category-edit {\n  padding: 24px;\n}\n.category-list .category-header-container {\n  display: flex;\n  justify-content: space-between;\n  margin-bottom: 20px;\n}\n\n.category-header-container .blog-header {\n  font-size: 2rem;\n  font-weight: 600;\n  font-family: Poppins;\n}\n\n.input {\n  width: 100% !important;\n}\n\n/* --------------------------Global css------------------------- */\n.category-add .btn-flex,\n.category-edit .btn-flex {\n  display: flex;\n  margin-right: -20px;\n}\n.category-add .btn-flex .btn-container,\n.category-edit .btn-flex .btn-container {\n  margin-right: 20px;\n}\n\n.category-add .MuiPaper-root.MuiPaper-elevation .MuiAccordionDetails-root,\n.category-edit .MuiPaper-root.MuiPaper-elevation .MuiAccordionDetails-root {\n  padding: 0px !important;\n}\n\n.category-add .MuiPaper-root.MuiPaper-elevation:last-of-type,\n.category-edit .MuiPaper-root.MuiPaper-elevation:last-of-type {\n  position: fixed !important;\n  top: 50% !important;\n  left: 50% !important;\n  width: 90% !important;\n  max-width: 900px !important;\n  max-height: 90vh !important;\n  transform: translate(-50%, -50%) !important;\n  overflow-y: auto !important;\n  margin: 0 !important;\n  z-index: 1400 !important; /* Higher than default MUI modal z-index */\n  box-shadow: 0 11px 15px -7px rgba(0,0,0,0.2), \n              0 24px 38px 3px rgba(0,0,0,0.14), \n              0 9px 46px 8px rgba(0,0,0,0.12) !important;\n}\n\n/* Custom scrollbar */\n.category-add .MuiPaper-root.MuiPaper-elevation:last-of-type::-webkit-scrollbar,\n.category-edit .MuiPaper-root.MuiPaper-elevation:last-of-type::-webkit-scrollbar {\n  width: 6px;\n}\n\n.category-add .MuiPaper-root.MuiPaper-elevation:last-of-type::-webkit-scrollbar-track,\n.category-edit .MuiPaper-root.MuiPaper-elevation:last-of-type::-webkit-scrollbar-track {\n  background: #f1f1f1;\n}\n\n.category-add .MuiPaper-root.MuiPaper-elevation:last-of-type::-webkit-scrollbar-thumb,\n.category-edit .MuiPaper-root.MuiPaper-elevation:last-of-type::-webkit-scrollbar-thumb {\n  background: #888;\n  border-radius: 4px;\n}\n\n.category-add .MuiPaper-root.MuiPaper-elevation:last-of-type::-webkit-scrollbar-thumb:hover,\n.category-edit .MuiPaper-root.MuiPaper-elevation:last-of-type::-webkit-scrollbar-thumb:hover {\n  background: #555;\n}\n\n/* Responsive adjustments */\n@media (min-width: 600px) {\n  .category-add .MuiPaper-root.MuiPaper-elevation:last-of-type,\n  .category-edit .MuiPaper-root.MuiPaper-elevation:last-of-type {\n    width: 85% !important;\n  }\n}\n\n@media (min-width: 900px) {\n  .category-add .MuiPaper-root.MuiPaper-elevation:last-of-type,\n  .category-edit .MuiPaper-root.MuiPaper-elevation:last-of-type {\n    width: 75% !important;\n  }\n}\n\n@media (min-width: 1200px) {\n  .category-add .MuiPaper-root.MuiPaper-elevation:last-of-type,\n  .category-edit .MuiPaper-root.MuiPaper-elevation:last-of-type {\n    width: 60% !important;\n  }\n}\n.Quil-one,\n.Quil-two {\n  padding: 0px 16px 16px;\n}\n\n.category-add .btn-group,\n.category-edit .btn-group {\n  display: flex;\n  padding: 8px 16px 16px;\n  justify-content: end;\n}\n\n.category-add .quil-close-btn,\n.category-edit .quil-close-btn {\n  margin-right: 10px;\n}\n\n/* category add component style */\n\n.category-add .category-header-container {\n  display: flex;\n  justify-content: space-between;\n  margin-bottom: 20px;\n}\n\n.container {\n  margin-top: 60px;\n  display: flex;\n  align-items: center;\n}\n.label {\n  /* font-size: 20px; */\n  font-family: Poppins;\n  font-size: 16px;\n  font-weight: 600;\n  margin: 0.3rem 0 0.2rem 0;\n  color: #333;\n  width: 25%;\n}\n.input {\n  width: 100%;\n  padding: 8px;\n}\n\n.Quil-maodal-header {\n  background-color: ghostwhite;\n  padding: 10px;\n  display: flex;\n  justify-content: space-between;\n  font-family: \"Roboto\", \"Helvetica\", \"Arial\", sans-serif;\n  font-weight: 400;\n  font-size: 1rem;\n  line-height: 1.5;\n  letter-spacing: 0.00938em;\n  font-weight: 600;\n}\n\n.Quil-one .title {\n  font-weight: 600;\n}\n.Quil-two .title {\n  font-weight: 600;\n}\n\n/* ------------------Edit Category style-------- */\n\n.category-edit .category-header-container {\n  display: flex;\n  justify-content: space-between;\n  margin-bottom: 20px;\n  font-size: 2rem;\n  font-weight: 600;\n  font-family: Poppins;\n}\n\n.category-edit .container {\n  align-items: center;\n}\n.question {\n  font-family: \"Roboto\", \"Helvetica\", \"Arial\", sans-serif;\n  font-weight: 700;\n  font-size: 0.875rem;\n  display: grid;\n  grid-template-columns: 100px 500px;\n  column-gap: 10px;\n}\n.answer {\n  font-family: \"Roboto\", \"Helvetica\", \"Arial\", sans-serif;\n  font-weight: 700;\n  font-size: 0.875rem;\n  margin-top: 25px;\n  display: grid;\n  grid-template-columns: 100px 500px 50px 50px;\n  column-gap: 10px;\n}\n\n.quest-header {\n  margin-right: 40px;\n}\n\n.category-edit .Quil-one,\n.Quil-two {\n  padding: 0px 16px 16px;\n  font-family: Poppins;\n  font-size: 16px;\n\n  margin: 0.3rem 0 0.2rem 0;\n  color: #333;\n}\n\n.category-add .Quil-one .ql-container,\n.Quil-two .ql-container {\n  height: 80px !important;\n}\n.category-edit .Quil-one,\n.Quil-two title {\n  font-family: Poppins;\n  font-size: 16px;\n  margin: 0.3rem 0 0.2rem 0;\n  color: #333;\n}\n\n/* --------------------category-card---------------------- */\n.category-card-container {\n  width: calc(25% - 20px);\n  margin: 10px;\n}\n\n.card-que-body {\n  /* padding: 0.5rem;\n  border-radius: 4px; */\n  /* outline: none; */\n  /* border: 1px solid #d1cece; */\n  /* font-size: 16px; */\n}\n\n.faqs-error {\n  font-family: Poppins;\n  font-size: 14px;\n  font-weight: 600;\n  color: #f53232;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
